import { useMediaQuery } from "@mui/material";
import React from "react";
import { theme } from "@/theme";
import { Button } from "@/components/Button";
import { PageModule } from "@/components/PageModule";
import Sticky from "@/components/Sticky";
import { useBfState } from "@/helpers/useBfState";
import { ImageList } from "@/components/ImageList";

export interface TrialFooterProps {
  items: BundleItem[];
  handleClick: () => void;
  viewProductsLink: string;
  numItems: number;
}

export type BundleItem = {
  id: number;
  quantity: number;
  image: string;
  title: string;
  pageLink: string;
};

export default function TrialFooter({
  items,
  handleClick,
  viewProductsLink,
  numItems,
}: TrialFooterProps) {
  const isMobile: boolean = useMediaQuery(
    theme.breakpoints.down(theme.breakpoints.values.md)
  );
  const [loading, setLoading] = useBfState(false);
  const showItemList = (numItems > 1 && items.length > 0) || !isMobile;

  return (
    <Sticky anchor={"bottom"} displayThreshold={isMobile ? 510 : 680}>
      <div className="scroll-shadows bg-white text-white">
        <PageModule className="h-16 py-2 md:h-20">
          <div
            className={`flex items-center ${
              showItemList ? "justify-between" : "justify-center"
            } w-full`}
          >
            {showItemList && (
              <div className="flex items-center">
                {!isMobile && (
                  <p className="body pr-4 font-semibold">Selected:</p>
                )}
                <ImageList
                  products={items.map((item) => ({
                    image: item.image,
                    pageLink: item.pageLink,
                    title: item.title,
                  }))}
                  numSpaces={numItems}
                  emptyStateLink={{
                    ariaLabel: "view products",
                    href: viewProductsLink,
                  }}
                />
              </div>
            )}
            <Button
              size={isMobile ? "md" : "lg"}
              onClick={() => {
                items.length > 0 && setLoading(true);
                handleClick();
              }}
              loading={loading}
            >
              {items.length === 0 ? "Get Started" : "Place Order"}
            </Button>
          </div>
        </PageModule>
      </div>
    </Sticky>
  );
}
